import {
  detachLayoutProps,
  WSElement,
  WSFlexBox,
  WSMarginProps,
  WSPanel,
  WSText
} from "@wingspanhq/fe-component-library";
import styles from "./Stepper.module.scss";
import { StepPoint } from "../Layout/StepPoint";
import { ModalFlowStep } from "./types";

interface ModalStepperProps<P extends object> extends WSMarginProps {
  steps: ModalFlowStep<P>[];
  currentStep: ModalFlowStep<P>;
  currentSubStep?: ModalFlowStep<P>;
  defaultStatuses?: boolean;
}

export function ModalStepper<P extends object>(props: ModalStepperProps<P>) {
  const {
    steps,
    currentStep,
    currentSubStep,
    defaultStatuses = true,
    ...otherProps
  } = props;

  const { layoutProps } = detachLayoutProps(otherProps);

  const activeSubIndex =
    currentStep?.steps?.findIndex(step => step.key === currentSubStep?.key) ||
    0;

  return currentStep?.steps ? (
    <WSPanel className={styles.stepper} {...layoutProps}>
      <WSFlexBox direction="column" mb="M" className={styles.stepTitles}>
        <WSText.ParagraphSm
          align="center"
          mb="XS"
          weight="medium"
          color="gray600"
        >
          {currentStep.title}
        </WSText.ParagraphSm>
        {currentSubStep ? (
          <WSText.ParagraphXs align="center" color="gray400" weight="medium">
            {`${activeSubIndex + 1}/${currentStep.steps?.length}`}:{" "}
            {currentSubStep?.title}
          </WSText.ParagraphXs>
        ) : null}
      </WSFlexBox>

      <WSElement className={styles.stepperContainer}>
        {currentStep.steps?.map((step, index) => {
          const isStepComplete = currentStep.status === "Complete";
          const isActive = index === activeSubIndex && !isStepComplete;
          const isPreviousSubStep = index < activeSubIndex;
          const isSubStepComplete =
            isStepComplete ||
            (isPreviousSubStep && defaultStatuses) ||
            isPreviousSubStep;
          const isLoading = currentStep.status === "Loading";

          return (
            <StepPoint
              key={String(index)}
              isActive={isActive}
              isLoading={isLoading}
              isComplete={isSubStepComplete}
            />
          );
        })}
      </WSElement>
    </WSPanel>
  ) : null;
}
